var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-list" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-12 col-lg-11" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "company-info" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "data" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm.isMobile
                    ? _c("div", { staticClass: "info" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _vm._m(4)
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(5),
                  _vm._v(" "),
                  _vm._m(6)
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                !_vm.isMobile
                  ? _c("div", { staticClass: "info" }, [
                      _vm._m(7),
                      _vm._v(" "),
                      _vm._m(8)
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-row" }, [
      _c("p", { staticClass: "p-title Raleway p-black" }, [
        _c("b", [_vm._v("We compare all power companies")])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "Raleway min-med p-dgrey" }, [
        _vm._v("Our goal is to be the best at what we do. "),
        _c("b", [_vm._v("TecknaEl.se")]),
        _vm._v(" compares "),
        _c("b", [_vm._v("143")]),
        _vm._v(
          " Sweden's electricity trading companies. Click on a company for more information."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "return" }, [
      _c("a", { staticClass: "return_link p-green", attrs: { href: "#" } }, [
        _c("img", {
          attrs: { src: "/img/icon/arrow-down-green.svg", alt: "" }
        }),
        _vm._v("Return to Company List")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "company__logo" }, [
      _c("img", { attrs: { src: "/img/telinet.svg", alt: "Telinet Energi" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name" }, [
      _c("p", { staticClass: "max-max p-blue" }, [_vm._v("Telinet Energi")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", { staticClass: "min p-light" }, [
        _vm._v(
          "Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources. Welcome to Telinet Energi"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "address-data" }, [
      _c("p", { staticClass: "min-min" }, [
        _c("b", [_vm._v("Org. Number:")]),
        _vm._v(" 559171-8522")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "min-min" }, [
        _c("b", [_vm._v("Address:")]),
        _vm._v(" Karlavägen 104, 115 26 Stockholm")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "min-min" }, [
        _c("b", [_vm._v("Turnover:")]),
        _vm._v(
          " 320 Msek Telinet Energi is the 5 biggest eletricity company of totaly 123 in Sweden."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "file__list" }, [
      _c("div", { staticClass: "file__item" }, [
        _c("img", { attrs: { src: "/img/icon/pdf.svg", alt: "" } }),
        _vm._v(" "),
        _c("a", { staticClass: "min", attrs: { href: "#" } }, [
          _vm._v("Contract terms Telinet Energi")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name" }, [
      _c("p", { staticClass: "max-max p-blue" }, [_vm._v("Telinet Energi")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", { staticClass: "min p-light" }, [
        _vm._v(
          "Cheap, cheap and cheap. Then you can summarize Telinet Energi with three words. For us, the price is everything. At the same time, we never compromise on the environment: all our electricity is green and comes from renewable sources. Welcome to Telinet Energi"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }